import SvgIcon from 'src/react_components/svg-icon';
import InfoPanel from './info-panel';
import { BurleyQAHeaderProps } from './types.d';

const BurleyQAHeader = (props: BurleyQAHeaderProps) => {
  const homePath = '#';
  const { meetingQaData } = props;

  const infos = [
    {
      label: 'Subject',
      value: meetingQaData?.subject_name
    },
    {
      label: 'Student Rating',
      value: meetingQaData?.student_rating || 'N/A'
    },
    {
      label: 'Student Comment',
      value: meetingQaData?.student_comment || 'N/A',
      paragraphClassName: 'student-comment',
      style: { maxWidth: '220px' }
    },
    {
      label: 'Reasons for review',
      value: meetingQaData.reasons_for_review?.join(', ')
    }
  ];

  return (
    <div
      id="qa-header"
      className="u-flex u-flexAlignItemsCenter u-gapXl u-paddingXl
        d-flex align-items-center gap-5 p-5"
    >
      <a
        href={homePath}
        className="u-flex u-flexShrink0 d-flex flex-shrink-0"
      >
        <img
          alt="Logo"
          title="Back to dashboard"
          src="/connect/assets/logos/studiosity-logo-small-dark.svg"
          className="logo"
        />
      </a>
      <div
        className="burley-qa-info-container u-flex u-flexAlignItemsStretch flex-expand-full u-gapXl u-overflowXHidden
          d-flex align-items-stretch flex-fill gap-5 overflow-hidden"
      >
        {infos.map((info) => (
          <div key={info.label} className="u-flexShrink0 flex-shrink-0">
            <h5>
              {info.label}
            </h5>
            <p className={info.paragraphClassName} style={info.style}>
              {info.value}
            </p>
          </div>
        ))}
      </div>
      <div className="qa-info-container u-flex u-flexAlignItemsCenter u-flexShrink0 u-gapSm
        d-flex align-items-center flex-shrink-0 gap-2"
      >
        <div className="u-flex u-flexAlignItemsCenter u-flexShrink0 u-gapXs
          d-flex align-items-center flex-shrink-0 gap-1"
        >
          <SvgIcon
            icon="error"
            className="icon-sm text-danger u-marginNone m-0"
          />

          <span className="qa-info u-fontWeight400 fw-normal">
            QA Information
          </span>
        </div>
        <InfoPanel {...meetingQaData} />
      </div>
    </div>
  );
};

export default BurleyQAHeader;
